{
  "adobeExperienceCloudNoOrgsSelect": "別の組織アカウントを選択",
  "appSwitcherLinkOutIconLabel": "新しいウィンドウで開く",
  "feedback button default": "フィードバック",
  "help": "ヘルプ",
  "launchsidebar": "サイドバーを起動",
  "more actions": "その他のアクション",
  "searchButton": "検索",
  "solutionSwitcher": "別のソリューションに切り替え",
  "solutionSwitcherList": "アプリケーション一覧",
  "solutionSwitcherPopover": "アプリケーション一覧のポップオーバー"
}
